import { isConfigSettled, useConfigSelection } from '@leagueplatform/core';

const defaultConfig: {
  masonry2MetricDetailsEnabled: boolean;
  metricDetailsMasonryConfigKey: string | undefined;
  allRecordedDataMasonryConfigKey: string | undefined;
  labs?: {
    labResultsLandingMasonryConfigKey: string;
    labResultDetailsMasonryConfigKey?: string;
  };
} = {
  masonry2MetricDetailsEnabled: false,
  metricDetailsMasonryConfigKey: undefined,
  allRecordedDataMasonryConfigKey: undefined,
  labs: undefined,
};

export function useDashboardConfig() {
  return useConfigSelection(
    (config) =>
      isConfigSettled(config)
        ? {
            masonry2MetricDetailsEnabled:
              config.config.release_about_me_masonry_2_for_metric_details,
            metricDetailsMasonryConfigKey:
              config.config.dashboard?.metricDetailsMasonryConfigKey,
            allRecordedDataMasonryConfigKey:
              config.config.dashboard?.allRecordedDataMasonryConfigKey,
            labs: config.config.dashboard?.labs,
          }
        : {},
    defaultConfig,
  );
}
